import { useEffect, useState } from "react";
import { ArrowUpRight, BookOpen, FileText, ClipboardCheck } from "lucide-react";
import { publicApi } from "@/lib/api";
import { Reveal } from "@/components/motion/Reveal";

const PLACEHOLDER = [
  { id: "r1", tipo: "Guía", titulo: "Preparación para una auditoría interna ISO 9001", resumen: "Checklist paso a paso para llegar preparado a la auditoría interna.", icon: ClipboardCheck },
  { id: "r2", tipo: "Artículo", titulo: "Errores comunes al implementar ISO 27001", resumen: "Aprende a evitar los tropiezos más frecuentes durante la implementación.", icon: FileText },
  { id: "r3", tipo: "Recurso", titulo: "Cómo estructurar un mapa de procesos efectivo", resumen: "Metodología práctica y ejemplos aplicables a diferentes industrias.", icon: BookOpen },
];

export default function Resources() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    publicApi.resources().then((r) => setItems(r.length ? r : PLACEHOLDER)).catch(() => setItems(PLACEHOLDER));
  }, []);

  return (
    <section id="recursos" className="relative py-24 md:py-32 border-t border-[#1A1A1A]/10" data-testid="resources-section">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <div className="grid grid-cols-12 gap-6 items-end mb-14">
          <Reveal className="col-span-12 md:col-span-8">
            <div className="eyebrow mb-6">— 10 · Recursos</div>
            <h2 className="display-2">Recursos para <em className="italic text-[#1B3B2B]">fortalecer</em> su organización.</h2>
          </Reveal>
          <Reveal delay={0.15} className="col-span-12 md:col-span-4 md:text-right">
            <a href="/recursos" className="kb-btn ghost" data-testid="resources-see-all">
              Ver todos los recursos <ArrowUpRight className="w-3.5 h-3.5" />
            </a>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.slice(0, 3).map((r, i) => {
            const Icon = r.icon || BookOpen;
            return (
              <Reveal key={r.id} delay={i * 0.08}>
                <a href="#recursos" className="group block border border-[#1A1A1A]/15 p-8 h-full hover:bg-[#EFEBE2] transition-colors" data-testid={`resource-${i}`}>
                  <div className="flex justify-between items-start">
                    <Icon className="w-6 h-6 text-[#1B3B2B]" strokeWidth={1.5} />
                    <span className="eyebrow">{r.tipo || "Artículo"}</span>
                  </div>
                  <h3 className="mt-8 font-serif text-2xl leading-tight">{r.titulo}</h3>
                  <p className="mt-3 text-sm text-[#4A4A4A] leading-relaxed">{r.resumen}</p>
                  <div className="mt-8 inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase link-underline">
                    Explorar <ArrowUpRight className="w-3 h-3" />
                  </div>
                </a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
